/** Offline-cache tuning for the Visite domain. Shared by the hooks and the persister. */

/** localStorage / AsyncStorage key under which the dehydrated visite cache is stored. */
export const VISITE_OFFLINE_CACHE_KEY = 'offertify-visite-cache';

/**
 * How long a persisted snapshot stays valid (24h). Also used as the query
 * `gcTime` so visite queries survive in memory long enough to keep being written
 * into every persisted snapshot even while no screen is observing them —
 * otherwise they'd be garbage-collected and disappear from the offline cache.
 */
export const VISITE_OFFLINE_MAX_AGE = 24 * 60 * 60 * 1000;

/**
 * Cache buster: bump when the persisted shape changes (e.g. Visita gains a field)
 * so stale snapshots from older app versions are discarded instead of hydrated.
 */
export const VISITE_OFFLINE_BUSTER = 'v1';
